/**
 * userinfo
 */
const userInfoKey = 'yingqiyu_ziubao_shop_wxuserinfo';

export const setUserInfo = (userInfo) => {
    localStorage.setItem(userInfoKey, JSON.stringify(userInfo));
}

export const getUserInfo = () => {
    const userInfoString = localStorage.getItem(userInfoKey);

    //
    if (userInfoString)
    {   
        return JSON.parse(userInfoString);
    }
}

export const clearUserInfo = () => {
    localStorage.removeItem(userInfoKey);
}

// token
const tokenKey = "yingqiyu_ziubao_shop_token";

export const setToken = (token) => {
    localStorage.setItem(tokenKey, token);
}

export const getToken = () => {
    return localStorage.getItem(tokenKey);
}